import { APPLICATION_ID } from '../constants';
import { generateCustomizedTheme } from './baseTheme';

import poulpeoTheme from './applicationSpecific/poulpeoTheme';

const themeMapping = {
    156: poulpeoTheme
};

const defaultThemeParams = {
    colors: {},
    fonts: {},
    screenSizes: {},
    overrideFunction: () => {}
};

export const theme = generateCustomizedTheme({
    ...defaultThemeParams,
    ...(themeMapping[APPLICATION_ID] || {})
});



// WEBPACK FOOTER //
// ./src/style/constants.js